import sha256 from 'crypto-js/sha256';

const SECRET_KEY = process.env.BET_SLIP_SIGN_SECRET_KEY;

interface Bet {
  coef: number;
  currency: string;
  outcomeIds: number[];
  possibleWin: number;
  bet: number;
  type: number;
  typeChanges: number;
}

export const generateBetslipSign = ({ outcomeIds, bet: betAmount }: Bet) => {
  const sortedOutcomeIdsString = outcomeIds.sort().join('');

  return sha256(
    `${sortedOutcomeIdsString}${parseInt(String(betAmount), 10)}${SECRET_KEY}`
  ).toString();
};
